import instance from "@/services/api/index";

export const nexoraApi = {
  // 403 = нет права OA__NexoraAssistant: это штатный случай, тост не показываем.
  async getToken() {
    return await instance(true, null, { showToast: false })
      .get("/nexora/assistant-token/")
      .then((res) => res?.data?.token || null)
      .catch(() => null);
  },
};
